import type { AsyncData } from "#app";
import type { IModelResponse } from "~/services/base/dto/base.dto";
import type { IModelModelResponse } from "./dto/model.dto";

export class ModelRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService
  }

  async getModel(): Promise<AsyncData<IModelResponse<IModelModelResponse[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/model`, this.configService);
    return dataResult;
  }
}